<script setup lang="ts">
    import { computed } from 'vue'

    const props = withDefaults(
        defineProps<{
            level?: 'info' | 'warning'
            icon?: string
        }>(),
        {
            level: 'info',
            icon: undefined,
        },
    )

    const iconName = computed(() => {
        if (props.icon) {
            return props.icon
        }
        return props.level === 'warning'
            ? 'ri:alert-line'
            : 'ri:information-line'
    })
</script>

<template>
    <div class="pk-infobox" :class="`pk-infobox--${level}`">
        <VvIcon :name="iconName" />
        <slot />
    </div>
</template>

<style lang="scss">
    @layer volver.components {
        .pk-infobox {
            font-size: var(--text-12);
            color: var(--color-word-3);
            line-height: var(--leading-normal);
            margin-bottom: var(--spacing-md);
            padding-block: var(--spacing-10);
            background-color: var(--color-surface-1);
            border: 1px solid var(--color-surface-3);
            padding-left: var(--spacing-36);
            padding-right: var(--spacing-xs);
            display: block;
            position: relative;
            border-radius: var(--rounded-lg);

            & > .vv-icon {
                font-size: var(--text-18);
                position: absolute;
                left: var(--spacing-8);
            }

            &--warning > .vv-icon {
                color: var(--color-warning);
            }
        }
    }
</style>
